import {
  listCards as publicListCards,
  getCard as publicGetCard,
  updateCard as publicUpdateCard,
  createCard as publicCreateCard,
  deleteCard as publicDeleteCard,
  moveCard as publicMoveCard,
  restoreCard as publicRestoreCard,
  archiveCard as publicArchiveCard,
} from './workflows-v1-card-cards.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listCards: MaybeContext<
  BuildRESTFunction<typeof publicListCards> & typeof publicListCards
> = /*#__PURE__*/ createRESTModule(publicListCards);
export const getCard: MaybeContext<
  BuildRESTFunction<typeof publicGetCard> & typeof publicGetCard
> = /*#__PURE__*/ createRESTModule(publicGetCard);
export const updateCard: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCard> & typeof publicUpdateCard
> = /*#__PURE__*/ createRESTModule(publicUpdateCard);
export const createCard: MaybeContext<
  BuildRESTFunction<typeof publicCreateCard> & typeof publicCreateCard
> = /*#__PURE__*/ createRESTModule(publicCreateCard);
export const deleteCard: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCard> & typeof publicDeleteCard
> = /*#__PURE__*/ createRESTModule(publicDeleteCard);
export const moveCard: MaybeContext<
  BuildRESTFunction<typeof publicMoveCard> & typeof publicMoveCard
> = /*#__PURE__*/ createRESTModule(publicMoveCard);
export const restoreCard: MaybeContext<
  BuildRESTFunction<typeof publicRestoreCard> & typeof publicRestoreCard
> = /*#__PURE__*/ createRESTModule(publicRestoreCard);
export const archiveCard: MaybeContext<
  BuildRESTFunction<typeof publicArchiveCard> & typeof publicArchiveCard
> = /*#__PURE__*/ createRESTModule(publicArchiveCard);

export {
  AttachmentType,
  SortOrder,
  WebhookIdentityType,
} from './workflows-v1-card-cards.universal.js';
export {
  Card,
  CardInfo,
  Attachment,
  QueryCardsRequest,
  Query,
  Sorting,
  Paging,
  QueryCardsResponse,
  PaginationResponse,
  ListCardsRequest,
  ListCardsResponse,
  GetCardRequest,
  GetCardResponse,
  UpdateCardRequest,
  UpdateCardResponse,
  CreateCardRequest,
  CreateCardResponse,
  DeleteCardRequest,
  DeleteCardResponse,
  MoveCardRequest,
  MoveCardResponse,
  RestoreCardRequest,
  RestoreCardResponse,
  ArchiveCardRequest,
  ArchiveCardResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  ListCardsOptions,
  CreateCardIdentifiers,
  CreateCardOptions,
  MoveCardOptions,
  RestoreCardOptions,
} from './workflows-v1-card-cards.universal.js';
export {
  AttachmentTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './workflows-v1-card-cards.universal.js';
